"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("../../constants");
var errors = {
  firstName: {
    required: _constants.FIRST_NAME_REQUIRED
  },
  lastName: {
    required: _constants.LAST_NAME_REQUIRED
  },
  accountNumber: {
    required: _constants.ACCOUNT_REQUIRED,
    lastFour: _constants.ACCOUNT_NUMBER_LAST_FOUR,
    validBankAccount: _constants.ACCOUNT_NUMBER_VALID
  },
  confirmAccountNumber: {
    required: _constants.CONFIRM_ACCOUNT_REQUIRED,
    lastFour: _constants.CONFIRM_ACCOUNT_NUMBER_LAST_FOUR,
    shouldMatchAccountNumber: _constants.CONFIRM_ACCOUNT_NUMBER_SHOULD_MATCH_ACCOUNT_NUMBER,
    validBankAccount: _constants.CONFIRM_ACCOUNT_NUMBER_VALID
  },
  routingNumber: {
    required: _constants.ROUTING_NUMBER_REQUIRED,
    validRoutingNumber: _constants.ROUTING_NUMBER_VALID
  }
};
var _default = errors;
exports["default"] = _default;
